module.exports = __webpack_public_path__ + "img/sample-01.3c0e7c76.png";